<template>
    <span class="d-flex align-items-center">

<svg xmlns="http://www.w3.org/2000/svg" width="15" height="18.4" viewBox="0 0 15 18.4"><title>Bookmark</title><path d="M13.28,17.8,8.06,13.92a.93.93,0,0,0-1.12,0L1.72,17.8A.82.82,0,0,1,.6,17.48a.87.87,0,0,1-.1-.39v-13A3.58,3.58,0,0,1,4.07.5h6.85A3.58,3.58,0,0,1,14.5,4.08v13a.82.82,0,0,1-.82.82A.79.79,0,0,1,13.28,17.8Z" fill="#4a90e2" stroke="#666" stroke-miterlimit="10"/></svg>
        <span class="badge badge-notify font-size-small font-weight-bold text-white bg-primary ml-1 mr-2">{{ count }}</span>

    </span>
</template>

<script>
    export default {
        props: ['initialcount'],

        data: function() {
            return {
                // Default count
                count: 0,
            }
        },

        mounted() {
            // Set count from passed parameter
            this.count = this.initialcount;

            // Subscribe to event (emitted by bookmark components)
            this.$eventBus.$on('bookmark.counter.updated', event => {
                // Update the counter
                this.count = event;
            });
        },

        beforeDestroy(){
            this.$eventBus.$off('bookmark.counter.updated');
        },

        computed: {
        },

        methods: {
        }
    }
</script>